<template>
  <div>
    <div
      class="panel"
      :class="{ 'is-danger': error || customErrors.length > 0 }"
    >
      <p class="panel-heading">Plik źródłowy</p>
      <div class="panel-block">
        <div class="control has-icons has-icons-left">
          <input
            v-model.trim="search"
            class="input is-small"
            type="text"
            placeholder="Wyszukaj plik źródłowy..."
          />
          <p class="icon is-left">
            <icon name="fa-search" />
          </p>
        </div>
      </div>

      <loader :state="state" without-loading>
        <template>
          <a
            class="panel-block"
            :class="{
              'is-active': source.path === value,
              'is-already-used':
                source.usedBy &&
                source.path !== value &&
                source.path !== initialValue
            }"
            v-for="(source, index) in sources"
            :key="index"
            @click="select(source)"
          >
            <span class="panel-icon">
              <icon name="fa-video" />
            </span>

            <p>
              <span class="source-volume">{{ source.path.split("/")[0] }}</span>
              {{ source.path.split("/")[1] }}
              <span
                class="used-by"
                v-if="
                  source.usedBy &&
                    source.path !== value &&
                    source.path !== initialValue
                "
              >
                <icon name="fa-chevron-right" />
                {{ source.usedBy.title }}
              </span>
            </p>
          </a>

          <div class="panel-block">
            <pagination
              class="is-centered is-small"
              :pageable="pageable"
              @change-page="changePage"
              :delta="1"
            />
          </div>

          <div class="panel-block choosen" v-if="value.length > 0">
            <span>
              <icon name="fa-check" />
              <span class="source-volume">{{ value.split("/")[0] }}</span>
              <span>{{ value.split("/")[1] }}</span>
            </span>
          </div>

          <div
            class="panel-block has-text-danger"
            v-if="error || customErrors.length > 0"
          >
            <span class="error">{{ error || customErrors[0] }}</span>
          </div>
        </template>

        <template #error>
          <div class="panel-block">
            <div class="grey-message">
              <icon name="fa-times-circle" />
              <p>Dane niedostępne z powodu braku połączenia z serwerem.</p>
            </div>
          </div>
        </template>
      </loader>
    </div>
  </div>
</template>

<script>
import { Icon, Pagination, Loader } from "%helpers";

export default {
  name: "video-source-picker",

  components: {
    Icon,
    Pagination,
    Loader
  },

  props: {
    sources: Array,
    value: String,
    error: String,
    pageable: Object,
    state: String
  },

  data() {
    return {
      search: "",
      customErrors: [],
      initialValue: ""
    };
  },

  mounted() {
    this.initialValue = this.value;
  },

  methods: {
    select(source) {
      if (!source.usedBy || source.path === this.initialValue) {
        this.$emit("input", source.path);
        this.customErrors = [];
      }
    },

    changePage(page) {
      this.$emit("change-page", page);
    },

    setErrors(errors) {
      this.customErrors = errors;
    }
  },

  watch: {
    search(value) {
      this.$emit("search", value);
    }
  }
};
</script>

<style lang="scss" scoped>
.source-volume {
  display: inline-block;
  color: $white;
  font-size: 0.55rem;
  font-weight: 700;
  padding: 0.1rem 0.3rem;
  background-color: $grey-light;
  border-radius: $radius-small;
  font-family: $family-sans-serif-condensed;
  vertical-align: middle;
}

.panel {
  &-heading {
    font-size: 1rem;
  }

  &-block {
    font-size: 0.9rem;

    &.is-active {
      color: $primary;

      .source-volume {
        background-color: $primary;
      }
    }

    &.is-already-used {
      cursor: not-allowed;
      color: $grey-light;

      &:hover {
        background: inherit;
      }
    }

    .used-by {
      font-size: 0.6rem;
      display: block;
    }
  }

  .pagination {
    width: 100%;
  }

  &.is-danger {
    border: solid 1px $danger;
  }

  .error {
    font-size: 0.75rem;
  }

  .choosen {
    cursor: default;
    color: $grey-light;
    font-size: 0.75rem;

    :not(:first-child) {
      display: inline-block;
      margin-left: 0.5rem;
    }
  }
}
</style>
